import {
  fetch,
  normalize,
  extractHubURL
} from '../../utils/dataAccess';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'LOGINHISTORY_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'LOGINHISTORY_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'LOGINHISTORY_LIST_SUCCESS', retrieved };
}

export function list(page = 'login_histories') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'LOGINHISTORY_LIST_RESET' });
  };
}

export function filter(filtersData) {
  return filterAction('LOGINHISTORY_LIST_FILTER', 'login_histories', filtersData)
}

export function sort(sortData) {
  return sortAction('LOGINHISTORY_LIST_SORT', 'login_histories', sortData)
}
